<template>
  <div class="container-fluid form-elements">
    <div class="myForm" v-show="!download.load">
      <div class="row">
        <div class="col-md-6">
          <input type="month" id='mes'>
        </div>
        <div class="col-md-6">
          <select id="pagantes" placeholder="pagantes" class="form-control form-control-sm">
            <option value="sim">Sim</option>
            <option value="nao">Não</option>
          </select>
        </div>
      </div>
      <div class="row form-row">
        <div class="col-md-12 savebtn">
          <button @click="getRelatorio()" class="btn btn-primary btn-micro">Gerar Relatório</button>
        </div>
      </div>
    </div>
    <div class="loader" v-show="download.load">
      <div class="row loader-el">
        <span>Pode demorar um pouco...</span>
      </div>
      <div class="row loader-el">
        <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../../../router/urlApi'

export default {
  name: 'relatorioComissaoColaborador',
  components: {
    ...spinners,
  },
  data () {
    return {
      download: {
        load: false
      },
    }
  },
  methods: {
    getRelatorio () {
      this.download.load = true

      var mes = document.getElementById('mes').value
      var pagantes = document.getElementById('pagantes').value

      if (mes == '') {
        this.$toasted.show('Selecione uma mês para consultar.', { position: 'top-right' })
        this.download.load = false
        return false
      }

      const url = `${urlApi}/relatorio-comercial/comissoes-de-colaboradores/${mes}/${pagantes}`

      this.$http.get(url).then((this.downloadPDF))
    },
    downloadPDF (response) {
      if (response.data) {
        var pdf = 'data:application/octet-stream;base64,' + response.data.dados
        var downloadPDF = document.getElementById('downloadPDF')
        downloadPDF.download = 'relatorio-aulas-praticas-enviadas-detalhadas.pdf'
        downloadPDF.href = pdf
        downloadPDF.click()
        this.download.load = false
      } else {
        this.$toasted.show('Consulta não possui resultado', {
          position: 'top-right',
        })
        this.download.load = false
      }
    },
  },
}
</script>
<style scoped>
.form-row{
  padding-top: 20px
}
.savebtn{
  display: flex;
  justify-content: center;
}
.loader{
  padding-top: 20px
}
.loader-el{
  display: flex;
  justify-content: center;
}
</style>
